import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGuzB4S2Ojld6qOgK3eGvKTZPDxpLNrJI",
  authDomain: "tagapp-9c6f5.firebaseapp.com",
  projectId: "tagapp-9c6f5",
  storageBucket: "tagapp-9c6f5.firebasestorage.app",
  messagingSenderId: "677688721707",
  appId: "1:677688721707:web:3d07c9d86626a15448456e",
  measurementId: "G-EF9ZQJB9K5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize messaging with error handling for unsupported browsers (iOS Safari, etc.)
let messaging = null;
try {
  // Check if messaging is supported in this browser
  if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
    messaging = getMessaging(app);
    console.log('✅ Firebase Messaging initialized');
  } else {
    console.warn('⚠️ Firebase Messaging not supported in this browser');
  }
} catch (error) {
  console.warn('⚠️ Firebase Messaging initialization failed (likely unsupported browser):', error.message);
  messaging = null;
}

export { messaging };

// VAPID key for web push notifications (you need to get this from Firebase Console)
// The VAPID key should be a base64-encoded string, typically 65+ characters long
export const vapidKey = "BEoi4RRUuQwRs_lwfvjHaPaMtpYn_iGbzGe9UcAV19WDiUy6OOlXTwBHy4ks14NVO50grwnf_gWFjwbUsL37Kqw"; // Replace with your actual VAPID key from Firebase Console
